document.addEventListener("DOMContentLoaded", () => {
  const hebrewFont = "'Rubik', sans-serif";
  const hebrewRegex = /[\u0590-\u05FF]/;

  const elements = document.querySelectorAll(".product-description *");

  if (elements) {
    elements.forEach(el => {
      const text = el.innerText || el.textContent;
      if (hebrewRegex.test(text)) {
        el.style.fontFamily = hebrewFont;
        el.style.textAlign = 'right'
      }
    });    
  }


  const notify_button = document.querySelector('#spb__notify-btn')
  const notify_modal = document.querySelector('#spb__bis-modal-overlay')

  if(notify_button && notify_modal) {
     notify_button.addEventListener('click', () => {
       notify_modal.classList.add('spb-opacity-100')
       notify_modal.classList.remove('spb-invisible')
    }) 
  }
});
